
export const requestBoilerplate = (formData) => {
    return JSON.stringify(convertFormDataToSession(formData))
}

export const convertFormDataToSession = (formData) => {   
    const {
        connectionType,
        socketAcceptorHostPort,
        socketConnectHostPort,
        routingDestination
    } = formData

    const session = {
        '@FixSessionCfg': {
            ...formData,
            // senderSubID may be an empty string, send as null if that is the case
            senderSubID: formData.senderSubID === '' ? null : formData.senderSubID,
            ...(connectionType === 'acceptor'
                ? {
                    socketAcceptorHostPort: socketAcceptorHostPort,
                    socketConnectHostPort: undefined,
                }
                : { 
                    socketAcceptorHostPort: undefined,
                    socketConnectHostPort: socketConnectHostPort.map((item) => item.value) 
                }),
            routingDestination: !!routingDestination
        }
    }

    return session
}

// Remove 'type' wrapper from object
export const unwrap = (obj) => {
    if (obj) {
        const objKeys = Object.keys(obj)
        if (objKeys.length === 1 && objKeys[0].startsWith('@')) {
            return obj[objKeys[0]]
        }
    }

    return obj
}

const fieldsToUnwrap = new Set([
    'connectionType',
    'fixVersion'
])

export const convertSessionToFormData = (session) => {
    const formData = { ...unwrap(session) }
    Object.entries(formData)
        .forEach(([name, value]) => {
            if (fieldsToUnwrap.has(name)) {
                formData[name] = unwrap(value)
            }
        })
    
    formData.socketConnectHostPort = 
        formData.socketConnectHostPort
            ? formData.socketConnectHostPort.map((el) => ({ value: el }))
            : [{ value: '' }]

    return formData
}

export const debounce = (func, timeout = 300) => {
    let timer
    return (...args) => {
        clearTimeout(timer)
        timer = setTimeout(() => {
            func.apply(this, args)
        }, timeout)
    }
}

export const hostPortRegex = "^[A-z0-9.-]+:[0-9]+$"
export const senderTargetCompIdRegex = "^[ -9;-~]+$"
